export const selectSearchQuery = state => state.notices.searchQuery;
export const selectFavorites = state => state.notices.favoritesArray;
export const selectOwn = state => state.notices.ownArray;
